import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { JobsPage } from "@/features/jobs/JobsPage";
import { jobsQuery } from "@/lib/api/queries";
import { DEFAULT_ENV, projectSearch } from "@/lib/search";

const search = projectSearch.extend({ mode: z.enum(["new"]).optional() });

export const Route = createFileRoute("/w/$workspace/p/$project/jobs/")({
  validateSearch: search,
  loaderDeps: ({ search: s }) => ({ env: s.env ?? DEFAULT_ENV }),
  loader: ({ context, params, deps }) =>
    context.queryClient.ensureQueryData(jobsQuery(params.workspace, params.project, deps.env)),
  component: () => {
    const { workspace, project } = Route.useParams();
    const s = Route.useSearch();
    const navigate = Route.useNavigate();
    return (
      <JobsPage
        workspace={workspace}
        project={project}
        env={s.env ?? DEFAULT_ENV}
        jobId={null}
        mode={s.mode ?? null}
        onMode={(jobId, mode) => {
          if (jobId)
            navigate({
              to: "/w/$workspace/p/$project/jobs/$jobId",
              params: { workspace, project, jobId },
              search: (prev) => ({
                env: prev.env,
                mode: mode === "edit" || mode === "override" ? mode : undefined,
              }),
            });
          else
            navigate({
              search: (prev) => ({ env: prev.env, mode: mode === "new" ? "new" : undefined }),
            });
        }}
      />
    );
  },
});
